const CallIcon = ({ viewBox = "0 0 20 20", className = "hayley-h-5 hayley-w-5 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path
        d="M12.3404 13.0763L10.5562 14.8338C9.6259 14.2724 8.7616 13.6082 7.97956 12.8538C7.22658 12.0714 6.56279 11.2077 6.00039 10.2788L7.75873 8.49464C7.86424 8.38676 7.9355 8.25008 7.96352 8.10179C7.99155 7.95351 7.97509 7.80025 7.91623 7.6613L6.08373 3.3838C6.0113 3.2153 5.88075 3.07843 5.71585 2.99813C5.55096 2.91782 5.36271 2.89943 5.18539 2.9463L1.82373 3.8338C1.65542 3.87742 1.50696 3.977 1.40277 4.11618C1.29857 4.25537 1.24483 4.42586 1.25039 4.59964C1.46449 8.50916 3.09012 12.2081 5.82539 15.0096C8.62787 17.7453 12.3282 19.3707 16.2387 19.5838C16.4123 19.5893 16.5825 19.5355 16.7214 19.4313C16.8603 19.3271 16.9596 19.1786 17.0029 19.0105L17.8912 15.6471C17.9383 15.4699 17.9201 15.2817 17.84 15.1168C17.7598 14.9518 17.623 14.8212 17.4546 14.7488L13.1804 12.9171C13.0405 12.8569 12.8857 12.8399 12.7361 12.8683C12.5864 12.8966 12.4486 12.9691 12.3404 13.0763Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M12.084 1.25C14.0731 1.25 15.9808 2.04018 17.3873 3.4467C18.7938 4.85322 19.584 6.76088 19.584 8.75"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M12.084 4.58301C13.1891 4.58301 14.2489 5.02199 15.0303 5.8034C15.8117 6.5848 16.2507 7.64461 16.2507 8.74967"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default CallIcon;
